import { render, staticRenderFns } from "./createFileOrFolder.vue?vue&type=template&id=ca038aa4"
import script from "./createFileOrFolder.vue?vue&type=script&lang=js"
export * from "./createFileOrFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports